const promotionType = {
  buyOneGiveOne: t => t('promotionType.buyOneGiveOne'),
  delivery: t => t('promotionType.delivery'),
  rateDiscount: t => t('promotionType.rateDiscount'),
  amountDiscount: t => t('promotionType.amountDiscount')
}

export default promotionType
